import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Updated service data based on the provided image
const servicesData = [
  {
    id: 1,
    title: "Restorative Dentistry",
    description:
      "We specialize in repairing and restoring the natural function and appearance of your teeth. From simple fillings to full mouth reconstructions, our goal is to bring your smile back to optimal health.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        ></path>
      </svg>
    ),
    image:
      "https://plus.unsplash.com/premium_photo-1661436618225-f9c72316215e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    services: [
      "Tooth Coloured Filling",
      "Root Canal Treatment",
      "Crown & Bridge",
      "Denture",
      "Full Mouth Rehabilitation",
    ],
  },
  {
    id: 2,
    title: "Cosmetic Dentistry",
    description:
      "Achieve the brilliant smile you've always dreamed of. Our cosmetic services are designed to enhance the aesthetics of your teeth, boosting your confidence with every smile.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    ),
    image:
      "https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    services: [
      "Veneers & Smile Designing",
      "Dental Jewellery",
      "Professional Teeth Whitening",
      "Gum Contouring",
    ],
  },
  {
    id: 3,
    title: "Orthodontics",
    description:
      "Straighten your teeth and align your bite with our advanced orthodontic solutions. We offer modern, comfortable, and effective treatments for both children and adults.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
        ></path>
      </svg>
    ),
    image:
      "https://images.unsplash.com/photo-1720685193964-4529228a33c1?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    services: ["Braces", "Aligners", "Retainers", "Orthodontic Consultation"],
  },
  {
    id: 4,
    title: "Implantology & Oral Surgery",
    description:
      "From permanent tooth replacements with dental implants to necessary surgical procedures, our expert team provides safe, effective, and lasting solutions for complex dental needs.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        ></path>
      </svg>
    ),
    image:
      "https://images.unsplash.com/photo-1739902526173-06750b78cfb7?q=80&w=869&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    services: [
      "Implants",
      "Removal of Teeth",
      "Oral Biopsy",
      "Maxillofacial Prosthesis",
    ],
  },
  {
    id: 5,
    title: "Pediatric Dentistry",
    description:
      "We provide gentle and specialized dental care for our youngest patients. Our friendly team creates a positive and comfortable environment to build a foundation of good oral health for life.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    ),
    image:
      "https://images.unsplash.com/photo-1684607631747-045ecfeeb4c7?q=80&w=1031&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    services: [
      "Child-Friendly Checkups",
      "Dental Sealants",
      "Fluoride Treatments",
      "Gentle Fillings for Kids",
    ],
  },
  {
    id: 6,
    title: "General & Preventive Care",
    description:
      "The foundation of a healthy smile starts here. Our preventive services, including professional cleanings and treatments for gum disease, are crucial for maintaining your oral health.",
    icon: (
      <svg
        className="w-12 h-12 text-blue-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    ),
    image:
      "https://images.unsplash.com/photo-1684607632829-1e5bf4f21dab?q=80&w=1031&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    services: [
      "Scaling",
      "Pyorrhea Treatment",
      "Comprehensive Dental Exams",
      "Digital X-Rays",
    ],
  },
];

const fadeInVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
    },
  }),
};

const Services: React.FC = () => {
  return (
    <div className="pt-24 md:pt-28 bg-slate-50">
      {/* Header Section */}
      <section className="bg-white text-center py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-5xl font-bold mb-4 text-slate-900"
          >
            Our Comprehensive Dental Services
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-xl max-w-3xl mx-auto text-slate-600"
          >
            At Ivory Dental, we deliver advanced treatments with a commitment to
            quality and patient comfort.
          </motion.p>
        </div>
      </section>

      {/* Services List Section */}
      <section className="py-16 md:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-16 md:gap-24">
            {servicesData.map((service, index) => (
              <div
                key={service.id}
                className={`flex flex-col ${
                  index % 2 !== 0 ? "lg:flex-row-reverse" : "lg:flex-row"
                } gap-8 md:gap-12 items-center`}
              >
                <motion.div
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="w-full lg:w-1/2"
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="rounded-lg shadow-xl w-full h-80 object-cover"
                  />
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="w-full lg:w-1/2"
                >
                  <div className="mb-4">{service.icon}</div>
                  <h2 className="text-3xl font-bold mb-4 text-slate-800">
                    {service.title}
                  </h2>
                  <p className="text-slate-600 mb-6">{service.description}</p>
                  <div>
                    <h3 className="text-lg font-semibold mb-3 text-blue-600">
                      Key treatments include:
                    </h3>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
                      {service.services.map((item, i) => (
                        <motion.li
                          key={i}
                          custom={i}
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.2 }}
                          variants={fadeInVariants}
                          className="flex items-center"
                        >
                          <svg
                            className="w-5 h-5 text-blue-500 mr-2 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                          <span className="text-slate-700">{item}</span>
                        </motion.li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready for a Healthier, Brighter Smile?
          </h2>
          <p className="max-w-3xl mx-auto mb-8 text-lg opacity-90">
            Our friendly team is here to provide you with the exceptional dental
            care you deserve. Contact us to book your appointment today!
          </p>
          <Link
            to="/appointment"
            className="bg-white text-blue-700 font-semibold py-3 px-8 rounded-lg hover:bg-slate-100 transition-all duration-300 transform hover:scale-105 inline-block shadow-lg"
          >
            Book Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
